// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1NTde","label":"Category_label__23RKS","content":"Category_content__3g5be","header":"Category_header__2RsHy","location":"Category_location__1Uc0Z"};